import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link, } from "react-router-dom";
import Toggle from '../Toggle';

function Header(props) {
  const {isDark, setisDark, target, labelContent} = props.attributes;
   return (
     <>
      <header className='header-area'>
        <Navbar>
          <Container>
            <div className='menu-container'>
              <div className='logo'>
                <Link to="/">
                  <Navbar.Brand>JAR</Navbar.Brand>
                </Link>
              </div>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
                  <Nav.Item as="li">
                    {/* <Nav.Link onClick={()=>props.changePage("home")}>Home</Nav.Link> */}
                    <Link to='/' className='nav-link'>Home</Link>
                  </Nav.Item>
                  <Nav.Item as="li">
                    {/* <Nav.Link onClick={()=>props.changePage("about")}>About</Nav.Link> */}
                    <Link to='/about' className='nav-link'>About</Link>
                  </Nav.Item>
                  <Nav.Item as="li">
                    {/* <Nav.Link onClick={()=>props.changePage("about")}>About</Nav.Link> */}
                    <Link to='/services' className='nav-link'>Services</Link>
                  </Nav.Item>
                  <Nav.Item as="li">
                    {/* <Nav.Link onClick={()=>props.changePage("about")}>About</Nav.Link> */}
                    <Link to='/projects' className='nav-link'>Projects</Link>
                  </Nav.Item>
                  {/* <NavDropdown title="Dropdown" id="basic-nav-dropdown">
                    <NavDropdown.Item>
                      <Link to='/services' className='nav-link'>Services</Link>
                    </NavDropdown.Item>
                    <NavDropdown.Item>
                      <Link to='/projects' className='nav-link'>Projects</Link>
                    </NavDropdown.Item>
                  </NavDropdown> */}
                </Nav>
              </Navbar.Collapse>
              <Toggle isChecked={isDark} handleChange={setisDark} target={target} labelContent={labelContent} />
            </div>
          </Container>
        </Navbar>
      </header>
     </>
   );
 }
 export default Header; 